module.exports = __webpack_public_path__ + "media/images/easypin/edit-546fb6ebcb3d2299eb5eafdb3b224b6f.png";